import {
  Avatar,
  Box,
  Grid,
  Link,
  Popover,
  Paper,
  Button,
  Menu,
  MenuItem,
  Popper,
  Grow,
  Checkbox
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ROOT, REST_LAST_PUNCH_ID_VIEW, UNDELETE_WORKER } from "navigation/CONSTANTS";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation, Link as RouterLink } from "react-router-dom";
import { callUnauth } from "services/firebaseAuthentication";
import Logo from "../assets/header.svg";
import LanguageSelection from "./LanguageSelection";
import ConfirmActionDialog from "components/ConfirmActionDialog";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { InputAdornment } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  assignDelegateManagers
} from "services";
import Confirmation from "components/Confirmation";
import { getManagerEmails } from "redux/actions/appActions";
import {
  DSC,
  ALL_ACTIVITIES,
  MANAGE_ACTIVITY_GROUP,
  INCOMPLETE_PUNCHES,
  MANAGE_WORKERS,
  MANAGE_TIMESHEET,
  REPORTS,
  ALL_HIGH_DURATION_ACTIVITIES,
  DASHBOARD_2_1,
  WARE_HOUSE_TIMELINE_VIEW,
  DSC_EMPLOYEE_LEVEL_PLANING,
} from "navigation/CONSTANTS";
import { properCase } from "utils";
import CheckBoxFilledIcon from '@material-ui/icons/CheckBox';
import CheckBoxBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import VirtualizeAutoComplete from './VirtualizedAutocomplete';
import Typography  from '@material-ui/core/Typography';
import {getUserImtRole} from '../redux/actions/userActions';
import {ADMIN, SUPER_USER, SUPPORT} from '../config';

const useStyles = makeStyles((theme) => ({
  logo: {
    minHeight: "32px",
  },
  header: {
    boxSizing: "border-box",
    padding: "0 24px",
    paddingLeft: theme.spacing(2),
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    zIndex: theme.zIndex.drawer + 100,
    borderRadius: 0,
    height: "48px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginRight: "200px"
  },
  link: {
    display: "flex",
  },
  box: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
    rowGap: "10px",
  },
  logoutText: {
    //padding: theme.spacing(2),
    cursor: "pointer",
    textAlign: "center",
  },
  innerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  menuButton: {
    // marginRight: 36,
  },
  hide: {
    display: "none",
  },
  containerAvatarLang: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  avatar: {
    maxHeight: "32px",
    maxWidth: "32px",
  },
  // navLinks: {
  //   display: "flex",
  //   alignItems: "center",
  //   "& a": {
  //     textDecoration: "none",
  //     mr: 4,
  //     color: "text.primary",
  //   },
  //   "& .notificationIcon": {
  //     mr: 2,
  //   },
  //   "& .notificationIcon svg": {
  //     ...fontrem(32),
  //   },
  // },
}));

const Header = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isLogoLinkDisabled } = props;
  // Markup for authenticated view.
  const { isAuthenticated, googleUser, user } = useSelector(
    (state) => state.user.auth
  );
  const { isLoading, userRole, error } = useSelector(
    (state) => state.user.imtRole
  );
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorMyTeam, setAnchorMyTeam] = useState(null);
  const [anchorPlanning, setAnchorPlanning] = useState(null);
  const [anchorReports, setAnchorReports] = useState(null);
  const openMyTeam = Boolean(anchorMyTeam);
  const openPlanning = Boolean(anchorPlanning);
  const openReports = Boolean(anchorReports);
  const profileHandler = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  const rootHandler = (event) => {
    event.preventDefault();
    history.push(ROOT);
  };
  const profileClose = () => {
    setAnchorEl(null);
  };
  const signoutUser = () => {
    profileClose();
    callUnauth();
  };
  //const open = Boolean(anchorEl);
  const [confirmationBox, setConfirmationBox] = useState({
    isOpen: false,
    title: t("pgPunch.tlConfirmation"),
    subTitle: t("pgReview.dialogueMsgs.msgSuccess"),
  });
  const [selectedDelegateManager, setSelectedDelegateManager] = useState([]);
  const [confirmDialogManagerDel, setConfirmDialogManagerDel] = useState({
    isOpen: false,
    title: t("other.assignDelMgrModalTitle"),
    subTitle: t("other.assignDelMgrModalSubTitle"),
    primaryAction: t("other.btnAssign"),
    secondaryAction: t("pgAddWorker.btnCancel"),
  });

  const [assignedDelManager, setAssignedDelManager] = useState([]);
  const updateDone = () => {
    setConfirmationBox({ ...confirmationBox, isOpen: false });
    setAnchorEl(null);
  };

  const isManager = isAuthenticated && user.isApprover && user.isActiveWorker;

  useEffect(() => {
    if (appConfig !== null) {
      if (appConfig.managerEmails == null) {
        dispatch(getManagerEmails());
      }
    }
  }, []);

  useEffect(()=>{
    if(isManager){
    dispatch(getUserImtRole(user.workerId))
    }
  },[isManager]) 

  const handledeleagteAssignClick = () => {

    if (assignedDelManager && assignedDelManager.length > 0) {
      setSelectedDelegateManager(assignedDelManager);
    } else {
      setSelectedDelegateManager([]);
    }
    setConfirmDialogManagerDel({
      ...confirmDialogManagerDel,
      title: t("other.assignDelMgrModalTitle"),
      subTitle: t("other.assignDelMgrModalSubTitle"),
      primaryAction: t("other.btnAssign"),
      secondaryAction: t("pgAddWorker.btnCancel"),
      disablePrimary: true,
      isOpen: true,
      childrenVisible: true,
    });
  };

  const handleResetPunchId = () =>{
    if(isManager && userRole && userRole.role && (userRole.role === ADMIN || userRole.role === SUPPORT)){
      console.log("Reset punch Id clicked>>");
      profileClose();
      history.push(REST_LAST_PUNCH_ID_VIEW)
    }
  }

  const handleUndeleteWorker = () =>{
    if(isManager && userRole && userRole.role && (userRole.role === ADMIN || userRole.role === SUPER_USER || userRole.role === SUPPORT)){
      console.log("Undelete worker clicked>>");
      profileClose();
      history.push(UNDELETE_WORKER)
    }
  }

  const handleAssignedConform = async (delegateWorker, loggedinWorker) => {
    if (loggedinWorker) {
      try {

        let removeDelegate = assignedDelManager.filter(ele => !delegateWorker.some(mgrDet => mgrDet.managerId === ele.managerId)).
            map(ele => ele?.managerId).filter(ele => ele!=="" && ele!==undefined && ele!==null);
        
        let addDelegate = delegateWorker.filter(ele => !assignedDelManager.some(mgrDet => mgrDet.managerId === ele.managerId)).
            map(ele => ele?.managerId).filter(ele => ele!=="" && ele!==undefined && ele!==null);
        
        let delegateWorkerIds = delegateWorker.length>0 ? delegateWorker.map(ele => ele.managerId).filter(ele => ele!=="" && ele!==undefined && ele!==null):[];     
        
        await assignDelegateManagers(loggedinWorker,delegateWorkerIds,addDelegate,removeDelegate)

        setConfirmDialogManagerDel({
          ...confirmDialogManagerDel,
          disablePrimary: true,
          isOpen: false,
          childrenVisible: true,
        });
        setConfirmationBox({
          ...confirmationBox,
          title: t("pgPunch.tlConfirmation"),
          subTitle: t("pgReview.dialogueMsgs.msgSuccess"),
          isOpen: true,
        });
        setAssignedDelManager(delegateWorker);
      } catch (err) {
        console.log(err);
        setConfirmationBox({
          ...confirmationBox,
          title: t("pgHome.errLoadingWorker"),
          subTitle: "",
          isOpen: true,
        });
      }
      console.log("delegateWorker###", delegateWorker, loggedinWorker);
    }
  };

  const appConfig = useSelector((state) => state.appConfig);
  const [delManagerOptions, setDelManagerOptions] = useState([]);

  const handleManagerChange = (event, worker) => {
    console.log("worker",worker,worker.filter(ele => !assignedDelManager.some(mgrDet => mgrDet.managerId === ele.managerId)))
    if (worker.length>0) {
      if (
        assignedDelManager.length === worker.length && !worker.filter(ele => !assignedDelManager.some(mgrDet => mgrDet.managerId === ele.managerId)).length>0
      ) {
        setConfirmDialogManagerDel({
          ...confirmDialogManagerDel,
          disablePrimary: true,
          isOpen: true,
          childrenVisible: true,
          primaryAction: t("other.btnAssign"),
        });
      } else {
        setConfirmDialogManagerDel({
          ...confirmDialogManagerDel,
          disablePrimary: false,
          isOpen: true,
          childrenVisible: true,
          primaryAction: t("other.btnAssign"),
          onConfirm: () => {
            handleAssignedConform(worker, user.workerId);
          },
        });
      }
      setSelectedDelegateManager(worker);
    } else if (
      !worker.length &&
      assignedDelManager &&
      assignedDelManager.length > 0
    ) {
      setConfirmDialogManagerDel({
        ...confirmDialogManagerDel,
        disablePrimary: false,
        isOpen: true,
        childrenVisible: true,
        primaryAction: t("pgAddWorker.btnSave"),
        onConfirm: () => {
          handleAssignedConform(worker, user.workerId);
        },
      });
      setSelectedDelegateManager(worker);
    } else {
      setConfirmDialogManagerDel({
        ...confirmDialogManagerDel,
        disablePrimary: true,
        isOpen: true,
        primaryAction: t("other.btnAssign"),
        childrenVisible: true,
      });
      setSelectedDelegateManager([]);
    }
  };

  useEffect(() => {
    if (appConfig && appConfig.managerEmails !== null && user.workerId) {
      let managerEmailOptions = appConfig.managerEmails.filter(
        (item) => item?.managerCountry && item.managerId !== user.workerId
      );
      setDelManagerOptions(managerEmailOptions);
      if (user?.delegateMgrId && user.delegateMgrId !== "" && user.delegateMgrId.length>0) {
        let assignedDelManagerDetails = appConfig.managerEmails.filter(
          (item) => {
            if(Array.isArray(user.delegateMgrId)){
              return item?.managerId && user.delegateMgrId.some(mgrDet => mgrDet === item.managerId)
            }else{
              return item?.managerId && user.delegateMgrId === item.managerId;
            }

          }
        );
        if(assignedDelManagerDetails.length > 0){
          setAssignedDelManager(assignedDelManagerDetails);
          setSelectedDelegateManager(assignedDelManagerDetails);
        }
      }
    }
  }, [appConfig, user]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const authMarkup = (
    <>
      <Link href="#" onClick={profileHandler}>
        <Avatar
          alt={googleUser.displayName}
          src={googleUser.photoURL}
          className={classes.avatar}
        />
      </Link>
      <Popover
        className={classes.popOver}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={profileClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box py={2} className={classes.box}>
        {isManager &&  <Link
            color="inherit"
            onClick={handledeleagteAssignClick}
            className={classes.logoutText}
          >
            {t("other.delegateMgrLink")}
          </Link>}

          {isManager && userRole && userRole.role && (userRole.role === ADMIN || userRole.role === SUPPORT) && <Link
            color="inherit"
            onClick={handleResetPunchId}
            className={classes.logoutText}
          >
            {t("other.resetPunchId")}
          </Link>}

          {isManager && userRole && userRole.role && (userRole.role === ADMIN || userRole.role === SUPER_USER || userRole.role === SUPPORT) && <Link
            color="inherit"
            onClick={handleUndeleteWorker}
            className={classes.logoutText}
          >
            {t("other.undeleteWorker")}
          </Link>}

          <Link
            color="inherit"
            className={classes.logoutText}
            onClick={signoutUser}
          >
            Sign out
          </Link>
        </Box>
      </Popover>
    </>
  );
  // Markup for authenticated view - end

  const onMyTeamClick = (e) => {
    setAnchorMyTeam(e.currentTarget);
  };

  const onPlanningClick = (e) => {
    setAnchorPlanning(e.currentTarget);
  };

  const onReportsClick = (e) => {
    setAnchorReports(e.currentTarget);
  };

  const handleCloseMyTeam = () => {
    setAnchorMyTeam(null);
  };

  const handleClosePlanning = () => {
    setAnchorPlanning(null);
  };

  const handleCloseReports = () => {
    setAnchorReports(null);
  };

  const navBarList = (
    <Grid
      container
      item
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      spacing={2}
    >
      <Grid item>
        <Button onClick={() => history.push(DASHBOARD_2_1)}>
        {t("other.lblDashboard")}</Button>
      </Grid>
      <Grid item>
        <Button
          onClick={onMyTeamClick}
          endIcon={<ExpandMoreIcon />}
          aria-haspopup="true"
          style={{
            color: "rgba(0, 0, 0, 0.87)",
            fontWeight: "none",
          }}
        >
         {t("other.lblMyTeam")}
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorMyTeam}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          open={openMyTeam}
          onClose={handleCloseMyTeam}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleCloseMyTeam}>
            <Link
              onClick={() => {
                history.push(MANAGE_TIMESHEET, { isTimesheetView: true });
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("other.lblManageTimesheets"))}
           
            </Link>
          </MenuItem>
          <MenuItem onClick={handleCloseMyTeam}>
            <Link
              onClick={() => {
                history.push(MANAGE_WORKERS, { isManageWorkers: true });
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("pgHome.btnManageWorkers"))}
        
            </Link>
          </MenuItem>
          <MenuItem onClick={handleCloseMyTeam}>
            <Link
              color="inherit"
              onClick={handledeleagteAssignClick}
              className={classes.logoutText}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("other.delegateMgrLink"))}
            </Link>
          </MenuItem>
        </Menu>
      </Grid>
      <Grid item>
        <Button
          onClick={onPlanningClick}
          endIcon={<ExpandMoreIcon />}
          aria-haspopup="true"
          style={{
            color: "rgba(0, 0, 0, 0.87)",
            fontWeight: "none",
          }}
        >
        {t("other.lblPlanning")}
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorPlanning}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          open={openPlanning}
          onClose={handleClosePlanning}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleClosePlanning}>
            <Link
              onClick={() => {
                history.push(MANAGE_ACTIVITY_GROUP, {
                  isManageActivityGroup: true,
                });
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("other.titleManageActivityGroup"))}
              
              
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClosePlanning}>
            <Link
              onClick={() => {
                history.push(DSC, { isDscView: true });
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("other.dscTitle"))}
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClosePlanning}>
            <Link
              onClick={() => {
                history.push(DSC_EMPLOYEE_LEVEL_PLANING, { isDscEmployeeLevelPlaningView: true });
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("other.dscEmployeeLevrlPlaningTitle"))}
            </Link>
          </MenuItem>
         </Menu>
      </Grid>
      <Grid item>
        <Button
          onClick={onReportsClick}
          endIcon={<ExpandMoreIcon />}
          aria-haspopup="true"
          style={{
            color: "rgba(0, 0, 0, 0.87)",
            fontWeight: "none",
          }}
        >
         {t("other.lblReports")}
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorReports}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          open={openReports}
          onClose={handleCloseReports}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {/* <MenuItem onClick={handleCloseReports}>
            <Link
              onClick={() => {
                // history.push(MANAGE_TIMESHEET, { isTimesheetView: true });
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase("Example 1")}
            </Link>
          </MenuItem> */}
          <MenuItem onClick={handleCloseReports}>
            <Link
              onClick={() => {
                history.push(INCOMPLETE_PUNCHES);
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("other.lblIncompleteActivities"))}
              {/* Incomplete Activities */}
            </Link>
          </MenuItem>
          <MenuItem onClick={handleCloseReports}>
            <Link
              onClick={() =>
                history.push(ALL_HIGH_DURATION_ACTIVITIES, {
                  isHighDuration: true,
                })
              }
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("other.HighDuration"))}
              {/* High Duration Activities */}
            </Link>
          </MenuItem>
          <MenuItem onClick={handleCloseReports}>
            <Link
              onClick={() => {
                history.push(REPORTS, {
                  isReportView: true,
                });
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {properCase(t("other.tlviewDetailedActivity"))}
              {/* Detailed Activity */}
            </Link>
          </MenuItem>
          <MenuItem onClick={handleCloseReports}>
            <Link
              onClick={() => {
                history.push(WARE_HOUSE_TIMELINE_VIEW);
              }}
              style={{
                textDecoration: "none",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
                   {properCase(t("other.lblTimelLineView"))}
              {/* Timeline View */}
            </Link>
          </MenuItem>
        </Menu>
      </Grid>
    </Grid>
  );

  return (
    <Box
      className={classes.header}
      square
      component={Paper}
      elevation={4}
      id="header-bar"
    >
      <Grid container alignItems="center" justify="space-between">
        <Grid item className={classes.innerContainer}>
          {/* to differentiate globalOpsSurvey screen and 
          Imtime dashboard header logo link */}
          {isLogoLinkDisabled ? (
            <Grid>
              <Link className={classes.link}>
                <img height="12" src={Logo} alt="Iron Mountain Logo" />
              </Link>
            </Grid>
          ) : (
            <Link className={classes.link} href="/">
              <img
                src={Logo}
                alt="Iron Mountain Logo"
                className={classes.logo}
              />
            </Link>
          )}
        </Grid>
        <div className={classes.containerAvatarLang}>
          <Grid container spacing={2}>
              <Grid item >
                <Box display={{ xs: "none", md: "block" }}>
                  {location.pathname === DASHBOARD_2_1 ||
                  location.pathname === WARE_HOUSE_TIMELINE_VIEW
                    ? navBarList
                    : null}
                </Box>
              </Grid>
          <Grid item>
            {
              // location.pathname==='/' &&   <LanguageSelection />
              (location.pathname === "/" ||
                location.pathname === "/globalOps-survey" || "/globalAndroid-survey" ||
                location.pathname === "/globalOps-surevy-success" || "/globalAndroid-survey-success") && (
                <LanguageSelection />
              )
            }
          </Grid>
          <Grid item>{isAuthenticated && user.email && authMarkup}</Grid>
          </Grid>
        </div>
      </Grid>
      <ConfirmActionDialog
        confirmDialog={confirmDialogManagerDel}
        setConfirmDialog={setConfirmDialogManagerDel}
      >
        <VirtualizeAutoComplete
          options={delManagerOptions}
          value={selectedDelegateManager}
          getOptionLabel={(option) =>
            option && option.managerFirstName
              ? option.managerFirstName + " " + option.managerLastName
              : ""
          }
          getOptionDisabled={(option) => (selectedDelegateManager.length === 3 && selectedDelegateManager.length>0 && !selectedDelegateManager.includes(option) ? true : false)}
          onChange={(event, worker) => handleManagerChange(event, worker, true)}
          id="employeeSearch"
          size="small"
          multiple
          style={{width:300}}
          disableCloseOnSelect
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={ selectedDelegateManager.length<3 ? t("other.searchManager"):""}
              size="small"
              // InputProps={{
              //   ...params.InputProps,
              //   startAdornment: (
              //     <InputAdornment position="start">
              //       <Search fontSize="small" />
              //     </InputAdornment>
              //   ),
              // }}
            />
          )}
          renderOption={(option,{selected})=>(
            <>
            {selected ? <CheckBoxFilledIcon style={{margin:"5px"}} color="primary" /> : <CheckBoxBlankIcon style={{margin:"5px"}} color="secondary" />}
            <Typography noWrap >
              {option && option.managerFirstName
                ? option.managerFirstName + " " + option.managerLastName
                : ""}
                </Typography>
            </>
          )}
        />
      </ConfirmActionDialog>
      <Confirmation
        confirmationMsg={confirmationBox.isOpen}
        closeModalConfirmationMsg={updateDone}
        confirmationMsgText={confirmationBox.subTitle}
        confirmationTitleText={confirmationBox.title}
      />
    </Box>
  );
};

export default Header;
